import type { SubTemplateValueSetupField } from '../../types/templateModel'
import { TemplateFieldValidationsCellContent } from './TemplateFieldValidationsCellContent'

type Props = {
  field: SubTemplateValueSetupField
}

export const CompositeFieldTypeValidationsCell = ({ field }: Props) => (
  <div className="flex size-full">
    <TemplateFieldValidationsCellContent field={field} />
  </div>
)
